export default __webpack_public_path__ + "static/inventory-optimisation-1-3e171d4aecf00645740e3840becf4fab.webp";